import { Injectable } from "@angular/core";
import { HttpService } from "../../service/http.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HomeService {
  constructor(private httpService: HttpService) {}

  getDashboardStockData(params: any): Observable<any> {
    return this.httpService.get("stock/dashboard-stock", params);
  }
  getDashboardPoAuto(params: any): Observable<any> {
    return this.httpService.get("po-auto", params);
  }
  getCounterData(cashierId: any, params: any): Observable<any> {
    return this.httpService.get(`cashier/${cashierId}/edit`, params);
  }
  getPoAutoSetting(params: any): Observable<any> {
    return this.httpService.get("po-auto-setting", params);
  }
  savePoSetting(params: any): Observable<any> {
    return this.httpService.post("po-auto-setting", params);
  }
  getMembershipSetting(params: any): Observable<any> {
    return this.httpService.get("membership-setting", params);
  }
  saveMembershipSetting(params: any): Observable<any> {
    return this.httpService.post("membership-setting", params);
  }
  saveSetupReminder(params: any): Observable<any> {
    return this.httpService.post("setup-reminder", params);
  }
  deleteReminder(params: any): Observable<any> {
    return this.httpService.post("delete-reminder", params);
  }
  nationalStock(params: any): Observable<any> {
    return this.httpService.post("national-stock", params);
  }
  nationalStockAll(data: any) {
    return this.httpService.post("national-stock-all", data);
  }
  getCabangList(): Observable<any> {
    return this.httpService.get("get-cabang-list");
  }
}
